// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import RegistrationMethodsNav from './RegistrationMethodsNav';
import { Route, Switch } from 'react-router-dom';
import ImportCsv from './ImportCsv';
import RegistrationForms from './RegistrationForms';
import ApiImport from './ApiImport';
import {
  SmallOutlineButton,
  MerchantRegistrationOptionDiv,
  MerchantReferralOptionDiv,
  OptionHeaderDiv,
  MerchantReferralOptionHeader,
  MerchantReferralContentDiv
} from './MerchantRegistrationsStyles';
import { MerchantsDiv } from '../../Merchants/MerchantsStyles';
import ReferralLink from '../../../components/ReferralLink';
import {
  PageHeaderDiv,
  PageHeaderP
} from '../../../components/PageHeaderStyles';

type Props = {
  apiKey: string,
  referralUrl: string,
  location: Location
};

class MerchantRegistrations extends Component<Props> {
  render() {
    return (
      <MerchantsDiv>
        <PageHeaderDiv>
          <PageHeaderP mobileCenter>
            We offer a few different ways for you to sign up merchants directly
            under your account. All different methods are listed below.
          </PageHeaderP>
        </PageHeaderDiv>
        {/* OPTION #1: REFERRAL LINK */}
        <MerchantReferralOptionDiv>
          <OptionHeaderDiv>
            <h5>Option 1</h5>
          </OptionHeaderDiv>
          <MerchantReferralContentDiv>
            <ReferralLink
              title="Share Your Merchant Referral Link"
              icon="link"
              copyableUrl={this.props.referralUrl}
            ></ReferralLink>
          </MerchantReferralContentDiv>
        </MerchantReferralOptionDiv>
        {/* OPTION #2: PARTNER CUSTOM SIGN UP PAGE*/}
        <MerchantReferralOptionDiv>
          <OptionHeaderDiv>
            <h5>Option 2</h5>
          </OptionHeaderDiv>
          <MerchantReferralContentDiv>
            <h5>Build a merchant signup page on your website.</h5>
            <MerchantRegistrationOptionDiv multiColumn>
              <div>
                <label>WordPress Plugin</label>
                <p>
                  If you’re running a wordpress website, then you can add a
                  custom signup page by installing our wordpress plugin.
                </p>
                <SmallOutlineButton
                  href="https://drive.google.com/file/d/1EX3xpNuY_NGcjWTyrEnvk9lqkXQyEmHy/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Wordpress plugin
                </SmallOutlineButton>
              </div>
              <div>
                <label>Other Platforms</label>
                <p>
                  If you are using a different platform or have a custom built
                  website then you can use our API to integrate the signup form.
                </p>
                <SmallOutlineButton
                  href="https://developers.net-cents.com/partner#merchant-registration"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {' '}
                  Api Docs
                </SmallOutlineButton>
              </div>
            </MerchantRegistrationOptionDiv>
          </MerchantReferralContentDiv>
        </MerchantReferralOptionDiv>
        {/* OPTION#3: PARTNER REGISTERS ON BEHALF OF MERCHANT */}
        <Switch>
          <Route
            exact
            path="/merchants/registrations/csv"
            render={props => <ImportCsv {...props} />}
          />
          <MerchantReferralOptionDiv
            largePaddingBottom={
              this.props.location.pathname.startsWith(
                '/merchants/registrations/form'
              ) ||
              this.props.location.pathname.startsWith(
                '/merchants/registrations/api'
              )
            }
          >
            <OptionHeaderDiv>
              <h5>Option 3</h5>
            </OptionHeaderDiv>
            <MerchantRegistrationOptionDiv>
              <MerchantReferralOptionHeader>
                <h5>Register on behalf of your merchants</h5>
                <p>
                  Register on behalf of your merchants by using one of the three
                  registration methods below.
                </p>
              </MerchantReferralOptionHeader>
            </MerchantRegistrationOptionDiv>
            <RegistrationMethodsNav
              isFormActive={() =>
                this.props.location.pathname.startsWith(
                  '/merchants/registrations/form'
                )
              }
            />
            <Route
              exact
              path="/merchants/registrations/api"
              render={props => (
                <ApiImport {...props} apiKey={this.props.apiKey} />
              )}
            />
            <Route
              // exact
              path="/merchants/registrations/form/:step"
              render={props => <RegistrationForms {...props} />}
            />
          </MerchantReferralOptionDiv>
        </Switch>
      </MerchantsDiv>
    );
  }
}

const mapStateToProps = state => ({
  apiKey: state.global.referralDetails.api_key,
  referralUrl: state.global.referralDetails.referral_link
});

export default connect(mapStateToProps)(MerchantRegistrations);
